import React, { useState } from 'react';

import MailchimpSubscribe from "react-mailchimp-subscribe"
import Layout from '@components/Layout';
import SEO from '@components/SEO';
import styles from './styles.module.scss';
import Input from '@components/Input';
import Alert from '@components/Alert';
import { useSnackbar } from '@components/Snackbar';
import { Col } from '@components/Grid';
import Button from '@components/Button';

const NewsletterSignup = () => {

    return (
        <Layout>
            <SEO title={"Newsletter Signup"} />
            <div className={styles.mailchimpWrapper}>
                <h1>Subscribe to our newsletter</h1>
                {/*<MailchimpSubscribe url={"URL goes here"} />*/}
                <MailchimpSubscribe
                    url={"url"}
                    render={({ subscribe, status, message }) => (
                        <CustomForm
                            status={status}
                            message={message}
                            onValidated={formData => subscribe(formData)}
                        />
                    )}
                />
            </div>
        </Layout>
    )
}

export default NewsletterSignup

const CustomForm = ({ status, message, onValidated }) => {
    const [openSnackbar] = useSnackbar();
    const [inputValue, setInputValue] = useState("")

    let email;

   const handleSubmit = () => {
       email &&
       email.value.indexOf("@") > -1 &&
       onValidated({
           EMAIL: email.value,
       });
       openSnackbar('Thank you for subscribing to our newsletter.');
   }

    return (
        <div
            className={styles.form}
        >
            <Input
                label="Your email address"
                ref={node => (email = node)}
                onChange={e => setInputValue(e.target.value)}
                type="email"
                placeholder="Email..."
                value={inputValue}
            />
            <br />
            <Button onClick={handleSubmit} text="Subscribe"/>
        </div>
    );
};